'use client';

import { Container } from '@mui/material';
import { AgentNetwork } from './agent-network';
import Header from './header';
import { PaymentMethod } from './payment-method';
import { TermCondition } from './term-condition';

export default function Page() {
  return (
    <div>
      <Header />
      <Container
        sx={{
          paddingBottom: {
            xs: '40px',
            md: '100px',
          },
        }}
      >
        <TermCondition />
      </Container>
      <AgentNetwork />
      <PaymentMethod />
    </div>
  );
}
